module.exports = __webpack_public_path__ + "static/img/img3.f0f7e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202212/img3.png
// module id = mR2X
// module chunks = 0